import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/registro_marca/producto';
import Producto from './ProductoList';

const ms2p = (state) => {
  return {
    ...state.rm_producto,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Producto);